import React, { type JSX } from "react";

/** Speech bubble hint — visible only before a feature is selected. */
export function SelectFeatureHint(): JSX.Element {
  return (
    <div
      className="absolute pointer-events-none z-10 animate-in fade-in slide-in-from-bottom-2 duration-200 hidden sm:block"
      style={{ bottom: "100%", left: "0" }}
      role="status"
      aria-live="polite"
    >
      {/* Bubble box — SVG tail is absolutely positioned below this box */}
      <div className="inline-block bg-white rounded-xl px-4 py-2.5 font-cvcBody border-2 border-cvc-blue max-w-[calc(100vw-2rem)]">
        <span className="text-sm font-semibold text-cvc-blue">Select a feature above</span>
        {/* Downward-pointing SVG tail — same pattern as Tooltip component */}
        <svg
          width="20"
          height="10"
          viewBox="0 0 20 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="absolute"
          style={{ bottom: "-10px", left: "16px" }}
          aria-hidden="true"
          focusable="false"
        >
          {/* Outer border path */}
          <path d="M 0 0 L 10 10 L 20 0 Z" fill="white" stroke="#0C4F88" strokeWidth="2" />
          {/* Inner white fill to cover the stroke on the top (flat) edge */}
          <path d="M 2 0 L 10 8 L 18 0 Z" fill="white" />
        </svg>
      </div>
    </div>
  );
}

/** Standing reminder that answers are model output, not a source of record. */
export function ChatInputFooter(): JSX.Element {
  return (
    <p className="text-xs text-center text-gray-400 mt-2">
      DealOS can make mistakes. Always check source documents.
    </p>
  );
}
